// 安全文件图片 / 本地图片回显 mixin
// 两类用法：
//  - setSecureImage(obj, field, path)：fetch /securefile/get 拿 blob（去 URL token），用于后端已存图片回显
//  - setLocalImage(obj, field, file)：本地 File 预览（el-upload 的 file.raw），用于上传时本地预览
// 内存回收：① 重新赋值时 revoke 旧 blob URL；② 组件销毁(beforeDestroy)时兜底 revoke 全部
export default {
  created() {
    // 非响应式实例属性：Vue 2 不代理 _ 开头的 data 属性，故挂实例上
    this._blobUrls = []
  },
  methods: {
    setSecureImage(obj, field, path) {
      if (!path) return
      const old = obj[field]
      if (old && old.indexOf('blob:') === 0) {
        window.URL.revokeObjectURL(old)
        const idx = this._blobUrls.indexOf(old)
        if (idx > -1) this._blobUrls.splice(idx, 1)
      }
      // axios 全局拦截器自动携带 XTOKEN(header)，无需拼入 URL
      this.$axios.get('/securefile/get?path=' + encodeURIComponent(path), { responseType: 'blob' })
        .then(res => {
          const url = window.URL.createObjectURL(res.data)
          this._blobUrls.push(url)
          this.$set(obj, field, url)
        })
        .catch(() => {})
    },
    setLocalImage(obj, field, file) {
      if (!file) return
      const old = obj[field]
      if (old && old.indexOf('blob:') === 0) {
        window.URL.revokeObjectURL(old)
        const idx = this._blobUrls.indexOf(old)
        if (idx > -1) this._blobUrls.splice(idx, 1)
      }
      const url = window.URL.createObjectURL(file)
      this._blobUrls.push(url)
      this.$set(obj, field, url)
    }
  },
  beforeDestroy() {
    if (this._blobUrls) {
      this._blobUrls.forEach(u => window.URL.revokeObjectURL(u))
      this._blobUrls = []
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/js/secureImageMixin.js